var React = require('react');

function DownArrowIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.50503 40.495C5.77839 40.7683 6.22161 40.7683 6.49497 40.495L10.9497 36.0402C11.2231 35.7668 11.2231 35.3236 10.9497 35.0503C10.6764 34.7769 10.2332 34.7769 9.9598 35.0503L6 39.0101L2.0402 35.0503C1.76683 34.7769 1.32362 34.7769 1.05025 35.0503C0.776885 35.3236 0.776885 35.7668 1.05025 36.0402L5.50503 40.495ZM6.7 40L6.7 -3.0598e-08L5.3 3.0598e-08L5.3 40L6.7 40Z","fill":"#FEFEFE"}));
}

DownArrowIcon.defaultProps = {"width":"12","height":"41","viewBox":"0 0 12 41","fill":"none"};

module.exports = DownArrowIcon;

DownArrowIcon.default = DownArrowIcon;
